import React from 'react';
import { urlApi, storageUrl } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg5.jpg';
import SectionTeam from '../Components/SectionTeam';
import { Col, Container, Row } from 'react-bootstrap';
import Photo1 from '../Medias/Photos/photo-bg4.jpg';
import Photo2 from '../Medias/Photos/photo-bg7.jpg';
import { Link } from 'react-router-dom';

const OurClient = ({ contents }) => {
  console.log(contents)

  return (
    <>
      <SectionHeader topic='Our Clients' detail={<span style={{ fontSize: '18px' }}>Our services at PT & Associates have created a track record of dedicated and efficient service that has been appreciated by our clients. The positive feedback that we receive from our clients encourages us to fulfill our role in developing Thailand’s energy industry.</span>} bg={Bg} textSize={10} />
      <section className='pt-5 pb-5'>
        <Container className='pt-5 pb-5'>
          <Row>
            <Col xs={{ span: 12, offset: 0 }} md={{ span: 6, offset: 3 }} className='px-5 pb-5 text-center mt-5 mt-md-0'>
              <div className='bg-img ratio-16x9' style={{ backgroundImage: `url(${Photo1})` }}></div>
              <h4 className='mt-3 font-header'>
                <Link to="/Testimonial" className='tx-color-primary text-decoration-none font-header'>Client Testimonials</Link>
              </h4>
            </Col>
            <Col xs={{ span: 12, offset: 0 }} md={{ span: 8, offset: 2 }} className='px-5 pt-5 text-center mt-5 mt-md-0'>
              {/* <div className='bg-img ratio-16x9' style={{ backgroundImage: `url(${Photo2})` }}></div> */}
              {/* <h4 className='mt-3'>
                <Link to="/Client" className='tx-color-primary text-decoration-none font-header'>Representative Clients</Link>
              </h4> */}
              <Row>
                {contents?.web_setup?.client_logo.map((item, index) => (
                  <Col xs={4} md={3} key={index} className='px-4'>
                    <div className='position-relative ratio-1x1'>
                      <img src={`${storageUrl}/media/${item.set1}`} className='w-100 position-absolute top-50 translate-middle' />
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default OurClient